import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  isOpen = false;
  isServicesExpanded = false;
  isAdminRoute = false;
  showContactModal = false;
  forceCloseMega = false;

  constructor(private router: Router) {
    // Check if the current route is an admin route
    this.isAdminRoute = window.location.pathname.startsWith('/admin');
    this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.closeMenu();
      this.isServicesExpanded = false;
    }
  });
  }

  toggleMenu(): void {
    this.isOpen = !this.isOpen;
  }

  closeMenu(): void {
    this.isOpen = false;
    this.isServicesExpanded = false;
  }

  toggleServices(event: Event): void {
    // Mobile-only accordion behavior; desktop uses hover.
    if (window.innerWidth < 1024) {
      event.preventDefault();
      this.isServicesExpanded = !this.isServicesExpanded;
    }
  }

  openContactModal(event?: Event): void {
    event?.stopPropagation();
    this.closeMenu();
    this.showContactModal = true;
  }

  closeContactModal(): void {
    this.showContactModal = false;
  }

  onServiceLinkClick(event?: Event): void {
    event?.stopPropagation();
    this.closeMenu();
    this.isServicesExpanded = false;
    this.forceCloseMega = true;
    // allow transition to finish then reset flag
    setTimeout(() => (this.forceCloseMega = false), 300);
  }
}
